// import http from './http'
// import api from './api'
import utils from './utils'

const install = (Vue) => {
  // Vue.prototype.$http = http
  // Vue.prototype.$api = api
  Vue.prototype.$utils = utils
}

export default { install }



// WEBPACK FOOTER //
// ./src/libs/index.js